import { render, staticRenderFns } from "./DashboardIndex.vue?vue&type=template&id=6834e4e8&scoped=true"
import script from "./DashboardIndex.vue?vue&type=script&lang=js"
export * from "./DashboardIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834e4e8",
  null
  
)

export default component.exports